import common_product_pro from '../PC/common_product_pro'
cb.define([], function() {
    var AA_aa_customerpro_VM_Extend = {
        doAction: function(name, viewmodel) {
            if (this[name]) {
                this[name](viewmodel);
            }
        },
        init: function(viewmodel) {
            common_product_pro(viewmodel)
        },
    }
    try {
        module.exports = AA_aa_customerpro_VM_Extend;
    } catch (error) {
        // 当 类型 为 档案 的时候
    }
    return AA_aa_customerpro_VM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_customerpro_VM.Extend.js